@if (!isModal) {
  <split-pane-main-header>
    <ion-buttons slot="end">
      <new-dataset-button></new-dataset-button>
    </ion-buttons>
  </split-pane-main-header>
  <split-pane-main-content [rootPath]="rootPath" secondaryContentType="routerOutlet">
    <div class="split-pane-main-col1-content">
      <ng-container *ngTemplateOutlet="ListPageTemplate"></ng-container>
    </div>
  </split-pane-main-content>
} @else {
  <ng-container *ngTemplateOutlet="ListPageTemplate"></ng-container>
}

<ng-template #ListPageTemplate>
  <ion-header mode="ios" class="ion-no-border">
    @if (isModal) {
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button fill="clear" color="dark" mode="ios" (click)="dismiss()">
            {{ 'BUTTON.CANCEL' | translate }}
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
          @if (enableAllSelection && isMultiSelect) {
            <ion-button fill="clear" color="primary" mode="ios" (click)="toggleSelectAllInFilter()">
              @if (allSelectedInFilter) {
                {{ 'BUTTON.CLEAR_SELECTION' | translate }}
              } @else {
                {{ 'BUTTON.SELECT_ALL' | translate }}
              }
            </ion-button>
          }
          <ion-button strong fill="clear" color="primary" mode="ios" (click)="submit()">
            {{ 'BUTTON.SAVE' | translate }}
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    }
    <search-toolbar
      [currentMultiFieldSearchValue]="currentSearchValue"
      [currentSecondarySearchValue]="currentSecondarySearchValue"
      [filterIsActive]="filterIsActive"
      [multiFieldSearchPlaceholderKey]="contactPersons ? 'VIEW.CONTACT_PERSON_PICKER.SEARCH_PLACEHOLDER' : 'VIEW.PERSON_LIST.SEARCH.PLACEHOLDER'"
      [searchOnInputChange]="true"
      [isLoading]="viewStates[currentContentId].isLoading"
      [showSkeleton]="viewStates[currentContentId].showSkeleton"
      [showLocationSearch]="true"
      (multiFieldSearchInput)="onSearchValueUpdated($event)"
      (secondarySearchInput)="onSecondarySearchValueUpdated($event)"
      (filterClicked)="onFilterButtonClicked()">
      <div class="toolbar-meta-wrapper">
        <div class="toolbar-meta">
          <span>{{ totalItemsInDatabase }} {{ 'TERM.SEARCH_RESULT' | translate }}</span>
          @if (!isPublicWebApp) {
            <ion-button class="search-info-button" color="primary" fill="clear" size="small" (click)="openSearchInfoPopover($event)">
              <ion-icon name="information-circle" slot="icon-only"></ion-icon>
            </ion-button>
            <ion-popover class="search-info-popover" mode="md"
              [event]="searchInfoPopoverEvent"
              [isOpen]="isSearchInfoPopoverOpen"
              (didDismiss)="isSearchInfoPopoverOpen = false"
              show-backdrop="false">
              <ng-template>
                <ion-content>
                  <div class="search-info-content">{{ (contactPersons
                    ? 'VIEW.CONTACT_PERSON_PICKER.SEARCH.MULTI_FIELD_TOOLTIP'
                    : 'VIEW.PERSON_LIST.SEARCH.MULTI_FIELD_TOOLTIP') | translate }}</div>
                </ion-content>
              </ng-template>
            </ion-popover>
          }
        </div>
      </div>
    </search-toolbar>
  </ion-header>
<ion-content class="nakos-list-content" #ListContent
  [ngClass]="{
    'modal-content': isModal,
    'show-skeleton': viewStates[currentContentId].showSkeleton,
    'is-loading': viewStates[currentContentId].isLoading }">
  <ion-refresher slot="fixed"
    [disabled]="viewStates[currentContentId].showSkeleton"
    (ionRefresh)="refresh(currentContentId, $event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <div class="proto-content">
    <ion-radio-group [ngModel]="selectedItemIds[0]">
      <ion-list lines="none">
        @for (item of items[currentContentId]; let i = $index; track item ? item.id : i) {
          @if (contactPersons) {
            <contact-person-preview [item]="$any(item)" (openDetail)="onItemClicked($event)">
              <ion-checkbox class="list-item-checkbox" [checked]="selectedItemIds.includes(item?.id)"></ion-checkbox>
            </contact-person-preview>
          } @else {
          <person-preview
            [ngClass]="{ 'is-selected': item?.id === activatedRouteId }" [type]="currentListType"
            [item]="item"
            (openDetail)="onItemClicked($event)">
            @if (isModal) {
              @if (!isMultiSelect) {
                <ion-radio class="list-item-checkbox" [value]="item?.id"></ion-radio>
              } @else {
                <ion-checkbox class="list-item-checkbox" [checked]="selectedItemIds.includes(item?.id)"></ion-checkbox>
              }

            }
          </person-preview>
          }
        }
      </ion-list>
    </ion-radio-group>


    @if (viewStates[currentContentId].isEmpty || viewStates[currentContentId].hasError) {
      <unavailable-block
        [viewStates]="viewStates[currentContentId]"
        (refresh)="refresh(currentContentId)">
      </unavailable-block>
    }
  </div>

  <ion-infinite-scroll
    [disabled]="!viewStates[currentContentId].hasMore"
    (ionInfinite)="loadMore(currentContentId, $event)">
    <ion-infinite-scroll-content>
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
</ng-template>
